<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <div class="left_tree">
        <div style="padding:var(--middle-space) var(--big-space)">
          <el-input v-model="filterText" placeholder="输入关键字进行过滤" size="small" clearable />
        </div>
        <org-tree ref="orgTree" :filter-text="filterText" @orgcurrent="currentOrgChangeHandler"></org-tree>
      </div>
    </div>
    <div class="bottom_right">
      <div class="right_button" style="display: inline-block">
        <el-form inline size="small" @submit.native.prevent>
          <el-form-item>
            <el-upload :disabled="upload || isSignature == 1 || !userID" :show-file-list="false"
              :before-upload="beforeUpload" :http-request="httpRequest" action="/" accept=".png,.jpg"
              style="display: inline-block; margin-right: var(--small-space)">
              <el-button v-if="uploadSignature" :disabled="isSignature == 1 || !userID" icon="el-icon-upload2"
                size="small" type="primary" @click="upLoadFile">
                上传
              </el-button>
            </el-upload>
            <input v-show="false" ref="upload-input" multiple accept=".png,.jpg" type="file"
              @change="multipleRequest" />
            <el-button v-if="batchupload" :disabled="personTable.length == 0" icon="el-icon-upload2" size="small"
              type="primary" @click.capture.stop="uploadBtn">
              批量上传
            </el-button>
            <el-button v-if="downSignature" :disabled="!userID" icon="el-icon-download" type="primary" size="small"
              plain @click="download">
              下载
            </el-button>
            <el-button v-if="deleSignature" :disabled="!userID" type="danger" size="small" plain
              @click="deleteSignature">
              删除签名
            </el-button>
          </el-form-item>
          <el-form-item label="搜索：" style="float: right;">
            <el-input v-model="searchQuery.keyword" placeholder="请输入登录名或姓名" size="small" style="width: 200px" clearable
              @input="getPersonList(1)">
              <template #prefix>
                <i class="el-icon-search el-input__icon" @click="getPersonList(1)" />
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="right_table">
        <orgPersonTable :person-table="personTable" :type="2" :show-selection="false" @handleChange="handleChange">
        </orgPersonTable>
      </div>
      <page :page="page" class="page-2" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
      </page>
    </div>
  </div>
</template>
<script>
import orgFrameworkConfig from "@/CommonDP/service/org-service";
import orgTree from "@/CommonDP/components/structure/orgTree.vue";
import page from "@/CommonDP/components/paging";
import orgPersonTable from "@/CommonDP/components/structure/orgPersonTable.vue";
import tzService from "@/CommonDP/service/tz-service";
import { mapState } from "vuex";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
export default {
  name: "Signature",
  components: { orgTree, orgPersonTable, page },
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      currentID: {},
      currentRow: {},
      personTable: [],
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      searchQuery: {
        keyword: ""
      },
      userID: undefined,
      upload: false,
      isSignature: undefined,
      filterText: "",
      uploadSignature: checkPermission(this.$allPerms.SIGNATURE_UPLOAD),
      batchupload: checkPermission(this.$allPerms.SIGNATURE_BATCHUPLOAD),
      downSignature: checkPermission(this.$allPerms.SIGNATURE_DOWN),
      editSignature: checkPermission(this.$allPerms.SIGNATURE_EDIT),
      deleSignature: checkPermission(this.$allPerms.SIGNATURE_DALE)
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },

  methods: {
    async beforeUpload({ name }) {
      return /\.png$/.test(name);
    },
    upLoadFile() {
      const a = disablePrompt();
      if (!a) {
        this.upload = true;
      }
    },
    async httpRequest({ file }) {
      const id = this.userID;
      const filename = file.name.substring(0, file.name.lastIndexOf("."));
      if (id) {
        if (this.isSignature === 0 || !this.isSignature) {
          if (filename === this.currentRow.username) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("sortId", id);
            const res = await tzService.uploadElectronic(formData);
            if (res.result === "0") {
              this.$message.success("上传成功");
              await this.getupdatesignature();
              await this.getPersonList(1);
            }
          } else {
            this.$message.warning("请上传与登录名相同的文件");
          }
        } else {
          this.$message.warning("该人员已经存在签名");
        }
      } else {
        this.$message.warning("请先选择要上传的人员");
      }
    },
    uploadBtn() {
      const a = disablePrompt();
      if (a) {
        this.$confirm("请选择与登录名相同的文件", "友情提示", {
          confirmButtonText: "确定上传",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const input = this.$refs["upload-input"];
            input.value = "";
            input.click();
          })
          .catch(error => error);
      }
    },
    async multipleRequest({ target }) {
      const depId = this.currentID.deptId || "";
      const enterpriseId = this.enterpriseId || "";
      const formData = new FormData();
      for (const item of target.files) {
        formData.append("file", item);
      }
      formData.append("depId", depId);
      formData.append("enterpriseId", enterpriseId);
      const res = await tzService.batchUploadsignature(formData);
      if (res.result === "0") {
        this.$message.success("上传成功");
      }
      await this.getupdatesignature();
      await this.getPersonList(1);
    },
    async getupdatesignature() {
      const id = this.userID;
      await tzService.updatesignature(id);
    },
    currentOrgChangeHandler(val) {
      this.currentID = val;
      this.getPersonList(1);
      this.userID = undefined;
    },
    handleCurrentChange(val) {
      this.getPersonList(val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getPersonList(1);
    },
    getPersonList(index) {
      const deptId = this.currentID.deptId;
      const {
        page: { pageSize },
        searchQuery: { keyword },
        enterpriseId
      } = this;
      var params = {
        deptId,
        keyword,
        pageNum: index,
        pageSize,
        enterpriseId,
        isQueryAll: 1
      };
      orgFrameworkConfig.orgUserList(params).then(({ data, totalCount, pageNum }) => {
        this.page.pageNum = pageNum;
        this.page.totalCount = totalCount;
        this.personTable = data;
        this.userID = undefined;
        this.isSignature = undefined;
      });
    },
    handleChange(val) {
      this.isSignature = val.isSignature;
      this.currentRow = val;
      this.userID = val.userId;
    },
    // 下载
    async download() {
      const a = disablePrompt();
      if (a) {
        if (this.isSignature === 1) {
          const fileID = this.userID;
          tzService.stampDownload(fileID).then(blob => {
            if (blob.type === "application/json") {
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                const jsonData = JSON.parse(fileReader.result);
                // 后台信息
                this.$message({ message: jsonData.message, type: "error" });
              };
              fileReader.readAsText(blob); // 或者读取response.data
            } else {
              if ("msSaveOrOpenBlob" in navigator) {
                // 兼容ie
                window.navigator.msSaveOrOpenBlob(blob, blob + "");
              } else {
                const link = document.createElement("a");
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", blob);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }
          });
          this.getPersonList(1);
        } else {
          this.$message.warning("没有个性签名，请先上传");
        }
      }
    },
    async deleteSignature() {
      const a = disablePrompt();
      if (a) {
        if (this.isSignature === 1) {
          const { userID } = this;
          const params = { userID };
          const res = await tzService.deletesignature(params);
          this.$message.success("删除成功");
          await this.getupdatesignature();
        } else {
          this.$message("没有个性签名，请先上传");
        }
        await this.getPersonList(1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 52px;
$middle-height: 30px;
$left-width: 280px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  min-width: 1080px;
  .bottom_left {
    position: absolute;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    width: $left-width;
    padding-left: 12px;
    border-right: 1px solid #ebefff;
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 10px;
      right: 0;
      display: flex;
      flex-direction: column;
    }
  }
  .bottom_right {
    position: relative;
    height: 100%;
    margin-left: $left-width;
    display: flex;
    flex-direction: column;
    .right_button {
      padding: var(--middle-space) var(--big-space) 0;
    }
    .right_table {
      height: 1px;
      flex-grow: 1;
      padding: 0 var(--big-space);
    }
  }
}
::v-deep .el-form-item__label {
  line-height: 32px;
}
::v-deep .el-form-item__content {
  line-height: 32px;
}

.page-2 {
  padding: var(--middle-space) var(--big-space);
  margin-left: auto;
}
</style>
